import InnerPageHeading from "./InnerPageHeading";

function ProjectDetails(){
    return(
        <>
            <InnerPageHeading title="Projects"/>
            <section className="gfe-sec">
                <div className="container">
                    <div className="cooming-soon">
                        Page Comming Soon...
                    </div>
                </div>
           </section>
        </>
    );
}

export default ProjectDetails;